import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.some";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.search";
import "core-js/modules/web.dom-collections.for-each";
import { __assign, __awaiter, __decorate, __extends, __generator, __spreadArrays } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { loading, userPrefPageSize, validateRuleData } from '@/decorators';
import { OperatingStatus, OperatingStatusText, enabledStatus } from '@/enum';
import { namespace } from 'vuex-class';
var ValidateRule = namespace('validateRule');

var CustomerRolePage = function (_super) {
  __extends(CustomerRolePage, _super);

  function CustomerRolePage() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.baseRoleformDataRule = {
      role_name: {
        trigger: 'blur'
      },
      is_enabled: {
        trigger: 'change'
      }
    };
    _this.addRoleFormDataRule = {};
    _this.editRoleFormDataRule = {};
    _this.roleFormDataRule = {};
    _this.permissionFormDataRule = {};
    _this.keyValuePermissionData = {};
    _this.operatingStatusText = OperatingStatusText;
    _this.roleTableLoading = false;
    _this.enabledStatus = enabledStatus;
    _this.roleModalVisible = false;
    _this.rolePermissionModelVisible = false;
    _this.labelCol = {
      span: 6
    };
    _this.wrapperCol = {
      span: 14
    };
    _this.selectedIdList = [];
    _this.rowSelection = {};
    _this.total = 0;
    _this.columns = [];
    _this.formData = _this.initFormData();
    _this.searchData = _this.initSearchData();
    _this.loadingStatus = false;
    _this.permissionListLoading = false;
    _this.visible = false;
    _this.data = [];
    _this.permissionData = [];
    _this.permissionIds = [];
    _this.permissionIdsAll = [];
    _this.isViewPermission = false;
    _this.permissionFormData = {
      role_id: 0,
      role_name: '',
      permission_id_list: []
    };
    _this.roleFormOperatingStatus = OperatingStatus.add;
    _this.expandedKeys = [];
    _this.isEexpanded = false;
    _this.viewPermissionData = {
      data: [],
      keyValuePermissionData: {}
    };
    _this.statusData = enabledStatus;
    _this.permissionOperate = {
      isAllowEditRolePermission: true,
      lockTips: ''
    };
    return _this;
  }

  CustomerRolePage.prototype.initSearchData = function () {
    return {
      field: 'role_name',
      value: '',
      is_enabled: undefined,
      page_index: 1,
      page_size: 20
    };
  };

  CustomerRolePage.prototype.initFormData = function () {
    return {
      role_name: '',
      is_enabled: this.$enum.common.BoolIntEnum.YES
    };
  };

  CustomerRolePage.prototype.createdAddRoleValidateRuleData = function (validateRule) {
    this.addRoleFormDataRule = this.$util.mergeValidate(validateRule, this.baseRoleformDataRule);
  };

  CustomerRolePage.prototype.createdUpdateRoleValidateRuleData = function (validateRule) {
    this.editRoleFormDataRule = this.$util.mergeValidate(validateRule, this.baseRoleformDataRule);
  };

  CustomerRolePage.prototype.saveRolePermissionValidateRuleData = function (validateRule) {
    this.permissionFormDataRule = this.$util.mergeValidate(validateRule, {
      permission_id_list: {
        trigger: 'change'
      }
    });
  };

  CustomerRolePage.prototype.queryList = function (params) {
    return __awaiter(this, void 0, Promise, function () {
      var res;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.rowSelection.selectedRowKeys = this.selectedIdList = [];
            return [4, this.$api.role.queryList(params)];

          case 1:
            res = _a.sent();

            if (res.code === 0) {
              this.data = res.data.data;
              this.total = res.data.total;
            }

            return [2];
        }
      });
    });
  };

  CustomerRolePage.prototype.queryPermissionTrees = function (params) {
    return __awaiter(this, void 0, Promise, function () {
      var res, permissionIds_1, permissionIdsAll_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.permissionData = [];
            return [4, this.$api.role.queryPermissionTrees(params)];

          case 1:
            res = _a.sent();

            if (res.code === 0) {
              permissionIds_1 = [];
              permissionIdsAll_1 = [];
              this.permissionData = this.$util.processingTreeData(res.data, function (item) {
                item.key = item.id;
                item.scopedSlots = {
                  title: 'title'
                };
                permissionIdsAll_1.push(item.id);

                if (item.has_permission) {
                  permissionIds_1.push(item.id);
                }
              });
              this.permissionIds = permissionIds_1;
              this.permissionIdsAll = permissionIdsAll_1;
              this.keyValuePermissionData = this.createdKeyValuePermissionData(this.permissionData);
              this.viewPermissionData.data = this.getViewPermissionData(this.permissionData);
              this.viewPermissionData.keyValuePermissionData = this.createdKeyValuePermissionData(this.viewPermissionData.data);
              this.permissionFormData.permission_id_list = this.filterParentPermission(this.keyValuePermissionData, permissionIds_1);
            }

            return [2];
        }
      });
    });
  };

  CustomerRolePage.prototype.addRole = function (params) {
    return __awaiter(this, void 0, Promise, function () {
      var res;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.role.add(params)];

          case 1:
            res = _a.sent();

            if (res.code === 0) {
              this.$message.success(this.t('common', '添加成功'));
              this.roleModalVisible = false;
              this.search();
            }

            return [2];
        }
      });
    });
  };

  CustomerRolePage.prototype.updateRole = function (params) {
    return __awaiter(this, void 0, Promise, function () {
      var res;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.role.update(params)];

          case 1:
            res = _a.sent();

            if (res.code === 0) {
              this.$message.success(this.t('common', '更新成功'));
              this.roleModalVisible = false;
              this.search();
            }

            return [2];
        }
      });
    });
  };

  CustomerRolePage.prototype.enableRole = function (params) {
    return __awaiter(this, void 0, Promise, function () {
      var res;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.role.enable(params)];

          case 1:
            res = _a.sent();

            if (res.code === 0) {
              this.$message.success(this.t('common', '操作成功'));
              this.search();
            }

            return [2];
        }
      });
    });
  };

  CustomerRolePage.prototype.disableRole = function (params) {
    return __awaiter(this, void 0, Promise, function () {
      var res;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.role.disable(params)];

          case 1:
            res = _a.sent();

            if (res.code === 0) {
              this.$message.success(this.t('common', '操作成功'));
              this.search();
            }

            return [2];
        }
      });
    });
  };

  CustomerRolePage.prototype.updatePermission = function (params) {
    return __awaiter(this, void 0, Promise, function () {
      var p, res;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            p = {
              role_id: params.role_id,
              permission_id_list: params.permission_id_list
            };
            return [4, this.$api.role.updatePermissison(p)];

          case 1:
            res = _a.sent();

            if (res.code === 0) {
              this.$message.success(this.t('common', '更新成功'));
              this.rolePermissionModelVisible = false;
            }

            return [2];
        }
      });
    });
  };

  CustomerRolePage.prototype.exportRoleList = function (params) {
    return __awaiter(this, void 0, Promise, function () {
      var res;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.role.exportRoleList(params)];

          case 1:
            res = _a.sent();
            this.$util.exportExcel(res.data);
            return [2];
        }
      });
    });
  };

  CustomerRolePage.prototype.handleSearch = function () {
    return __awaiter(this, void 0, Promise, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.search()];

          case 1:
            _a.sent();

            return [2];
        }
      });
    });
  };

  CustomerRolePage.prototype.handleClear = function () {
    return __awaiter(this, void 0, Promise, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.searchData = this.initSearchData();
            return [4, this.search()];

          case 1:
            _a.sent();

            return [2];
        }
      });
    });
  };

  CustomerRolePage.prototype.handleExportAll = function () {
    this.exportRoleList({
      field: this.searchData.field,
      value: this.searchData.value,
      is_enabled: this.searchData.is_enabled
    });
  };

  CustomerRolePage.prototype.handleExportSelected = function () {
    if (!this.selectedIdList.length) {
      this.$message.warning(this.t('请勾选导出项'));
      return;
    }

    this.exportRoleList({
      ids: this.selectedIdList
    });
  };

  CustomerRolePage.prototype.handleAdd = function () {
    return __awaiter(this, void 0, Promise, function () {
      return __generator(this, function (_a) {
        this.roleFormDataRule = this.addRoleFormDataRule;
        this.roleFormOperatingStatus = OperatingStatus.add;
        this.formData = this.initFormData();
        this.roleModalVisible = true;
        return [2];
      });
    });
  };

  CustomerRolePage.prototype.handleEdit = function (data) {
    return __awaiter(this, void 0, Promise, function () {
      return __generator(this, function (_a) {
        this.roleFormDataRule = this.editRoleFormDataRule;
        this.roleFormOperatingStatus = OperatingStatus.edit;
        this.formData = {
          id: data.id,
          role_name: data.role_name,
          is_enabled: data.is_enabled
        };
        this.roleModalVisible = true;
        return [2];
      });
    });
  };

  CustomerRolePage.prototype.handleAddOrUpdateRole = function () {
    var _this = this;

    var formDataRef = this.$refs.formDataRef;
    formDataRef.validate(function (valid) {
      if (valid) {
        if (_this.roleFormOperatingStatus === OperatingStatus.add) {
          _this.addRole(_this.formData);
        } else if (_this.roleFormOperatingStatus === OperatingStatus.edit) {
          _this.updateRole(_this.formData);
        }
      }
    });
  };

  CustomerRolePage.prototype.handleCheck = function (checkedKeys, info) {
    var _this = this;

    var previousCheckedKeys = JSON.parse(JSON.stringify(this.permissionFormData.permission_id_list));

    if (this.isViewPermission) {
      var allKeys_1 = Object.keys(this.viewPermissionData.keyValuePermissionData);
      var otherKeys = this.permissionFormData.permission_id_list.filter(function (id) {
        return !allKeys_1.includes(String(id));
      });
      var checkedMinChildrenKeys = checkedKeys.filter(function (item) {
        var _a;

        return !((_a = _this.keyValuePermissionData[item].children) === null || _a === void 0 ? void 0 : _a.length);
      });
      this.permissionFormData.permission_id_list = __spreadArrays(otherKeys, checkedMinChildrenKeys);
    } else {
      this.permissionFormData.permission_id_list = checkedKeys;
    }

    this.handleCheckHomePermission(previousCheckedKeys);
  };

  CustomerRolePage.prototype.handleCheckHomePermission = function (previousCheckedKeys) {
    var homePermissionId = this.findHomePermissionId();

    if (!homePermissionId) {
      return;
    }

    var isHomePermissionUnchecked = previousCheckedKeys.includes(homePermissionId) && !this.permissionFormData.permission_id_list.includes(homePermissionId);

    if (isHomePermissionUnchecked) {
      return;
    }

    var hasNewChecked = this.permissionFormData.permission_id_list.some(function (id) {
      return !previousCheckedKeys.includes(id) && id !== homePermissionId;
    });

    if (this.permissionFormData.permission_id_list.length > 0 && hasNewChecked) {
      if (!this.permissionFormData.permission_id_list.includes(homePermissionId)) {
        this.permissionFormData.permission_id_list.push(homePermissionId);
      }
    }
  };

  CustomerRolePage.prototype.findHomePermissionId = function () {
    for (var key in this.keyValuePermissionData) {
      var item = this.keyValuePermissionData[key];

      if (item.action_name === 'home') {
        return item.id;
      }
    }

    return null;
  };

  CustomerRolePage.prototype.handleConfigPermission = function (data) {
    return __awaiter(this, void 0, Promise, function () {
      return __generator(this, function (_a) {
        this.isViewPermission = false;
        this.permissionFormData = {
          role_id: data.id,
          role_name: data.role_name,
          permission_id_list: []
        };
        this.queryPermissionTrees({
          role_id: data.id
        });
        this.getBigList();
        this.rolePermissionModelVisible = true;
        return [2];
      });
    });
  };

  CustomerRolePage.prototype.handleExpandedKeys = function (type) {
    if (type === void 0) {
      type = 'empty';
    }

    this.isEexpanded = !this.isEexpanded;
    this.expandedKeys = type === 'empty' ? [] : this.permissionIdsAll;
  };

  CustomerRolePage.prototype.handleUpdatePermission = function () {
    var _this = this;

    var permissionFormRef = this.$refs.permissionFormRef;
    permissionFormRef.validate(function (valid) {
      if (valid) {
        var params = __assign({}, _this.permissionFormData);

        params.permission_id_list = _this.getCompletePermission(_this.permissionData, _this.permissionFormData.permission_id_list);

        _this.updatePermission(params);
      }
    });
  };

  CustomerRolePage.prototype.handlePageChange = function (page, pageSize) {
    this.searchData.page_index = page;
    this.searchData.page_size = pageSize;
    this.search();
  };

  CustomerRolePage.prototype.handleCancelFormData = function () {
    var formDataRef = this.$refs.formDataRef;
    formDataRef.resetFields();
  };

  CustomerRolePage.prototype.handleDisable = function () {
    if (!this.selectedIdList.length) {
      this.$message.warning(this.t('请勾选停用项'));
      return;
    }

    this.disableRole({
      id_list: this.selectedIdList
    });
  };

  CustomerRolePage.prototype.handleEnable = function () {
    if (!this.selectedIdList.length) {
      this.$message.warning(this.t('请勾选启用项'));
      return;
    }

    this.enableRole({
      id_list: this.selectedIdList
    });
  };

  CustomerRolePage.prototype.getViewPermissionData = function (data) {
    var _a;

    var arr = [];

    for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
      var item = data_1[_i];

      if (item.type === this.$enum.common.PermissionType.READ && !((_a = item.children) === null || _a === void 0 ? void 0 : _a.length)) {
        arr.push(__assign({}, item));
      }

      var children = this.getViewPermissionData(item.children);

      if (children === null || children === void 0 ? void 0 : children.length) {
        arr.push(__assign(__assign({}, item), {
          children: children
        }));
      }
    }

    return arr;
  };

  CustomerRolePage.prototype.createdKeyValuePermissionData = function (data) {
    var arr = this.$util.flattenTreeData(data, 0, 'id');
    return this.$util.arrayToObjectByKey(arr, 'id');
  };

  CustomerRolePage.prototype.getCompletePermission = function (data, selectedIdList) {
    selectedIdList = __spreadArrays(selectedIdList);

    for (var _i = 0, selectedIdList_1 = selectedIdList; _i < selectedIdList_1.length; _i++) {
      var id = selectedIdList_1[_i];
      var item = this.keyValuePermissionData[id];
      var parentId = item.parentId;

      if (parentId && selectedIdList.indexOf(parentId) === -1) {
        selectedIdList.push(parentId);
      }
    }

    return selectedIdList;
  };

  CustomerRolePage.prototype.filterParentPermission = function (data, selectedIdList) {
    selectedIdList = __spreadArrays(selectedIdList);
    var arr = [];
    selectedIdList.forEach(function (id) {
      var flag = true;

      for (var _i = 0, _a = Object.keys(data); _i < _a.length; _i++) {
        var key = _a[_i];
        var item = data[key];

        if (item.parentId === id) {
          flag = false;
          return false;
        }
      }

      if (flag) {
        arr.push(id);
      }
    });
    return arr;
  };

  CustomerRolePage.prototype.search = function () {
    this.queryList(this.searchData);
  };

  CustomerRolePage.prototype.created = function () {
    var _this = this;

    this.columns = [{
      title: this.t('角色'),
      dataIndex: 'role_name',
      filterEmpty: true,
      isCopy: true
    }, {
      title: this.t('状态'),
      dataIndex: 'is_enabled',
      scopedSlots: {
        customRender: 'is_enabled'
      }
    }, {
      title: this.t('创建时间'),
      dataIndex: 'created_at',
      filterEmpty: true
    }, {
      title: this.t('操作'),
      key: 'operation',
      fixed: 'right',
      width: 200,
      scopedSlots: {
        customRender: 'operation'
      }
    }];
    this.rowSelection = {
      selectedRowKeys: [],
      onChange: function onChange(selectedRowKeys) {
        _this.rowSelection.selectedRowKeys = _this.selectedIdList = selectedRowKeys;
      }
    };
    this.search();
  };

  CustomerRolePage.prototype.getBigList = function () {
    var _a, _b;

    return __awaiter(this, void 0, Promise, function () {
      var res, error_1;
      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            _c.trys.push([0, 2,, 3]);

            return [4, this.$api.common.queryBizList({
              showError: false
            })];

          case 1:
            res = _c.sent();
            this.permissionOperate.isAllowEditRolePermission = ((_a = res.data) === null || _a === void 0 ? void 0 : _a.is_allow_edit_role_permission) === false ? false : true;
            this.permissionOperate.lockTips = ((_b = res.data) === null || _b === void 0 ? void 0 : _b.lock_role_permission_operate_tips) || '';
            return [3, 3];

          case 2:
            error_1 = _c.sent();
            this.permissionOperate.isAllowEditRolePermission = true;
            this.permissionOperate.lockTips = '';
            return [3, 3];

          case 3:
            return [2];
        }
      });
    });
  };

  __decorate([ValidateRule.Action('getValidateRule')], CustomerRolePage.prototype, "getValidateRule", void 0);

  __decorate([userPrefPageSize('roleList')], CustomerRolePage.prototype, "initSearchData", null);

  __decorate([validateRuleData('/api/v1/role/add')], CustomerRolePage.prototype, "createdAddRoleValidateRuleData", null);

  __decorate([validateRuleData('/api/v1/role/update')], CustomerRolePage.prototype, "createdUpdateRoleValidateRuleData", null);

  __decorate([validateRuleData('/api/v1/permission/save_role_permissions')], CustomerRolePage.prototype, "saveRolePermissionValidateRuleData", null);

  __decorate([loading('roleTableLoading')], CustomerRolePage.prototype, "queryList", null);

  __decorate([loading('permissionListLoading')], CustomerRolePage.prototype, "queryPermissionTrees", null);

  __decorate([loading('loadingStatus')], CustomerRolePage.prototype, "handleSearch", null);

  CustomerRolePage = __decorate([Component], CustomerRolePage);
  return CustomerRolePage;
}(Vue);

export default CustomerRolePage;